import { z } from 'zod';
export const distributionAudienceSchema = z.enum(['owners', 'owners_and_renters', 'board']);
export const distributionRecipientKindSchema = z.enum(['owner', 'renter', 'board_member']);
export const distributionDeliveryModeSchema = z.enum(['individual', 'group']);
//# sourceMappingURL=documentDistribution.js.map